import { HttpClient } from '@angular/common/http';
import { Component, Inject, OnInit, Optional } from '@angular/core';
import { appConfigService, AppConfig } from '@app/config';
import { DynamicFormService } from '@ntap/common';
import {
  DataSource,
  ItemProvider,
  ListView,
  ListViewProviderDirective,
  NotificationService,
  NtapGlobalConstants,
  ServerItemAction,
  Util,
  ViewWindow
} from '@ntap/core';
import { Observable, filter, map, switchMap, take } from 'rxjs';

@Component({
  selector: 'app-export-agent-drugi-zapisi',
  templateUrl: './export-agent-drugi-zapisi.component.html'
})
export class ExportAgentDrugiZapisiComponent
  extends ServerItemAction
  implements OnInit
{
  constructor(
    protected override notificationService: NotificationService,
    @Optional() protected override itemProvider: ItemProvider,
    protected override dataSource: DataSource,
    @Optional() protected dynamicFormService: DynamicFormService,
    @Optional()
    protected override listViewProvider: ListViewProviderDirective<ListView>,
    @Optional() protected override window: ViewWindow,
    @Inject(appConfigService) private config: AppConfig,
    private http: HttpClient
  ) {
    super(notificationService, itemProvider, dataSource, listViewProvider);
    this.config = config;
    this.http = http;
  }

  enabled$: Observable<boolean>;

  private baseUrl = this.config.apiHost;

  ngOnInit(): void {
    if (this.listViewProvider) {
      this.enabled$ = this.listViewProvider?.selectedItems$.pipe(
        map((selected) => selected.length > 0 && selected.length < 2)
      );
    }
  }

  downloadAgentDrugiZapisi(): void {
    this.listViewProvider.selectedItems$
      .pipe(
        take(1),
        map((selectedItems: any[]) => {
          const firstItem = selectedItems[0];
          if (firstItem) {
            const mainType =
              firstItem[NtapGlobalConstants.ATTR_$itemType] ||
              firstItem[NtapGlobalConstants.ATTR_$mainType];
            return firstItem[Util.getFullAttrName(mainType, 'id')];
          }
          return null;
        }),
        filter((agentDrugiZapisiId) => agentDrugiZapisiId !== null),
        switchMap((agentDrugiZapisiId) => {
          const url = `${
            this.baseUrl
          }export-data/agent-drugi-zapisi?agentDrugiZapisiId=${agentDrugiZapisiId.toString()}`;
          return this.http
            .get(url, {
              responseType: 'blob'
            })
            .pipe(
              map((data) => {
                return {
                  agentDrugiZapisiId,
                  data: new Blob([data], { type: 'text/plain' })
                };
              })
            );
        })
      )
      .subscribe({
        next: ({ agentDrugiZapisiId, data }) => {
          const link = document.createElement('a');
          link.href = window.URL.createObjectURL(data);
          link.download = `agent_drugi_zapisi${agentDrugiZapisiId}.txt`;
          link.click();
        },
        error: (error) => {
          console.error('Error downloading agent drugi zapisi:', error);
        }
      });
  }
}
